export enum LineType {
  Unknown = 0,
  Advertising = 1,
  Service = 2,
}

export const LineTypeLabel: Record<LineType, string> = {
  [LineType.Unknown]: 'خطوط',
  [LineType.Advertising]: 'خطوط تبلیغاتی',
  [LineType.Service]: 'خطوط خدماتی',
};
